import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExpand = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.06641 5.00391L11.7578 1.3125H9.40625C9.02344 1.3125 8.75 1.03906 8.75 0.65625C8.75 0.300781 9.02344 0 9.40625 0H13.3164C13.6992 0 13.9727 0.300781 13.9727 0.65625V4.59375C13.9727 4.97656 13.6992 5.25 13.3164 5.25C12.9609 5.25 12.6602 4.97656 12.6602 4.59375V2.24219L8.96875 5.93359C8.72266 6.20703 8.3125 6.20703 8.06641 5.93359C7.79297 5.6875 7.79297 5.27734 8.06641 5.00391ZM5.93359 8.99609L2.21484 12.6875H4.59375C4.94922 12.6875 5.25 12.9883 5.25 13.3438C5.25 13.7266 4.94922 14 4.59375 14H0.65625C0.273438 14 0 13.7266 0 13.3438V9.40625C0 9.05078 0.273438 8.75 0.65625 8.75C1.01172 8.75 1.3125 9.05078 1.3125 9.40625V11.7852L5.00391 8.09375C5.25 7.82031 5.66016 7.82031 5.93359 8.09375C6.17969 8.33984 6.17969 8.75 5.93359 8.99609Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconExpand);
export { ForwardRef as ReactComponent };
